import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUsers,
  resetFilters,
  fetchUsersPerRole,
  setSelectedUsers
} from "../redux/rolesSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Assign = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    selected: { allUsers, selectedUsers }
  } = useSelector((state) => state.roles);

  const primaryBtnHandler = () => {
    dispatch(updateUsers());
    close();
  };

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchUsersPerRole());
    }
  }, [isOpen]);

  const onUsersChange = (data) => {
    dispatch(setSelectedUsers(data));
  };

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".roles"
      headerText="Assign Users"
      headerCloseHandler={close}
      bodyClassName="main-popup-body"
      primaryButtonText="Save"
      primaryButtonDisabled={false}
      primaryBtnHandler={primaryBtnHandler}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
      width={700}
      height={300}
      isLoading={!allUsers}
      loadingClass="popup__loading"
    >
      <Dropdown
        height={275}
        haveOnSelectChange
        placeholder="Select Users"
        options={allUsers}
        labelKey="name"
        selectedFilters={selectedUsers}
        numberDisplayed={1}
        includeSelectAll
        onSelectChange={(data) => onUsersChange(data)}
      />
    </MainModal>
  );
};
